import { FormControl, FormHelperText, OutlinedInput } from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import { makeStyles } from "@saleor/macaw-ui";
import cls from "classnames";
import React, { useState } from "react";

import MyTypography from "../MyTypography";
import { ISelectFieldProps } from "../SingleSelectField";

interface ISingleTextFieldV2 extends ISelectFieldProps {
  value?: string;
  isReset?: boolean;
  multiline?: boolean;
  size?: Partial<32 | 40 | 48 | 56>;
  className?: string;
  readOnly?: boolean;
  required?: boolean;
  labelFocus?: string;
  maxLengthProps?: number;
  regex?: RegExp;
  clearAble?: boolean;
  numberLimit?: number;
  id?: string;
  onKeyPress?(event: any);

  onMouseEnter?(event: any);
}

const useStyles = makeStyles(
  theme => ({
    error: {
      color: theme.palette.error.main
    },
    root: {
      width: "100%",
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: "1rem",
        "& .MuiSvgIcon-root": {
          color: theme.palette.grey[500],
          cursor: "pointer"
        }
      }
    }
  }),
  { name: "SingleTextField" }
);
export const SingleTextFieldV2: React.FC<ISingleTextFieldV2> = props => {
  const {
    disabled,
    label,
    value,
    onChange,
    onBlur,
    onKeyPress,
    name,
    hint,
    placeholder,
    error,
    multiline,
    className,
    readOnly,
    required,
    regex,
    maxLengthProps = 255,
    onMouseEnter,
    clearAble,
    numberLimit,
    id
  } = props;
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(value);
  const handleChange = event => {
    const value = event.target.value;
    if (
      value &&
      regex &&
      (!regex.test(value) || value.length > maxLengthProps)
    ) {
      return;
    }
    if (numberLimit) {
      if (Number(value) > numberLimit) {
        return;
      }
    }
    if (value.length <= maxLengthProps) {
      setInputValue(value);
      onChange({
        target: {
          name,
          value
        }
      });
    }
  };

  const clearValue = () => {
    onChange({
      target: {
        name,
        value: ""
      }
    });
  };

  return (
    <FormControl className={classes.root} error={error} disabled={disabled}>
      {label ? (
        <MyTypography variant="body3">
          {label} {required ? <span className={classes.error}>*</span> : ""}
        </MyTypography>
      ) : null}
      <OutlinedInput
        aria-describedby="outlined-weight-helper-text"
        autoComplete="off"
        error={error}
        value={inputValue}
        id={id}
        name={name}
        onMouseEnter={onMouseEnter}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={onBlur}
        onKeyDown={onKeyPress}
        multiline={multiline}
        readOnly={readOnly}
        className={cls(className)}
        endAdornment={
          clearAble && value ? <CloseOutlined onClick={clearValue} /> : ""
        }
      />
      {hint && <FormHelperText>{hint}</FormHelperText>}
    </FormControl>
  );
};
export default SingleTextFieldV2;
